// extracted by mini-css-extract-plugin
export default {"ModalWrapper":"modalWrapper_ModalWrapper__dww41","Backdrop":"modalWrapper_Backdrop__zub8N"};